export default "__VITE_ASSET__CA0trSpQ__"